<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thehistoryof50-2">
<p class="centerImage"><img alt="image" id="imgfr39" src="images/imgfr39.jpg"/></p>
<p class="caption1"><em class="italic">Order of St. George 2nd Class</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thehistoryof502.vue?3b037e58